module.exports = __webpack_public_path__ + "static/img/4.36e1321.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/eng/4.png
// module id = 7t62
// module chunks = 0